// extracted by mini-css-extract-plugin
module.exports = {"Returns":"styles_Returns__Kgw4t","title":"styles_title__8ai01"};